<template>
  <AppDialog
    ref="shellRef"
    size="lg"
    extra-class="vehicle-details-dialog"
    :title="$t('bike.name161')"
    :visible.sync="innerVisible"
    v-if="visible"
    :before-close="handleBeforeClose"
    @opened="handleOpened"
  >
    <EBikeDetailsDialog
      ref="detailsRef"
      :e-bike-id="eBikeId"
      :e-bike-code="eBikeCode"
      :type="type"
      @list-changed="$emit('list-changed')"
    />
  </AppDialog>
</template>

<script>
import AppDialog from '@/components/AppDialog/index.vue'
import EBikeDetailsDialog from '@/view/biketable/components/eBikeDetailsDialog.vue'
import { scheduleDialogScrollReset } from '@/utils/dialogScroll'

export default {
  name: 'VehicleDetailsAppDialog',
  components: {
    AppDialog,
    EBikeDetailsDialog
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    eBikeId: {
      type: String,
      default: ''
    },
    eBikeCode: {
      type: String,
      default: ''
    },
    type: {
      type: Number,
      default: 1
    }
  },
  computed: {
    innerVisible: {
      get () {
        return this.visible
      },
      set (val) {
        this.$emit('update:visible', val)
      }
    }
  },
  methods: {
    handleOpened () {
      this.$nextTick(() => {
        const shell = this.$refs.shellRef
        scheduleDialogScrollReset(shell && shell.$refs.dialogRef)
      })
    },
    handleBeforeClose (done) {
      this.close()
      if (typeof done === 'function') done()
    },
    close () {
      if (this.$refs.detailsRef) {
        this.$refs.detailsRef.close()
      }
      this.$emit('update:visible', false)
    }
  }
}
</script>
